export const CALL_SCHEDULE_NONE_VALUE = 'none'
export const CALL_SCHEDULE_OTHER_VALUE = 'other'
export const IS_CALL_PAID_YES_VALUE = 'yes'
const IS_CALL_PAID_NO_VALUE = 'no'
export const isCallPaidOptions = [
  { label: 'Yes', id: IS_CALL_PAID_YES_VALUE },
  { label: 'No', id: IS_CALL_PAID_NO_VALUE },
]

export const W2_TAX_STATUS = 'w2'
export const TEN_NINETY_NINE_TAX_STATUS = '1099'
export const K_ONE_TAX_STATUS = 'k1'
export const taxStatusOptions = [
  { label: 'W-2', id: W2_TAX_STATUS },
  { label: '1099', id: TEN_NINETY_NINE_TAX_STATUS },
  { label: 'K-1', id: K_ONE_TAX_STATUS },
]

const HOSPITAL_VALUE_PRACTICE_SETTING = 'hospital'
const ASC_VALUE_PRACTICE_SETTING = 'asc'
const CLINIC_VALUE_PRACTICE_SETTING = 'clinic'
const URGENT_CARE_VALUE_PRACTICE_SETTING = 'urgentCare'
const TELEMEDICINE_VALUE_PRACTICE_SETTING = 'telemedicine'
export const OTHER_VALUE_PRACTICE_SETTING = 'other'
export const practiceSettingOptions = [
  { label: 'Hospital', id: HOSPITAL_VALUE_PRACTICE_SETTING },
  { label: 'ASC', id: ASC_VALUE_PRACTICE_SETTING },
  { label: 'Clinic', id: CLINIC_VALUE_PRACTICE_SETTING },
  { label: 'Urgent Care', id: URGENT_CARE_VALUE_PRACTICE_SETTING },
  { label: 'Telemedicine', id: TELEMEDICINE_VALUE_PRACTICE_SETTING },
  { label: 'Other', id: OTHER_VALUE_PRACTICE_SETTING },
]
const estimatedFteOptions = [
  { label: '1.5', id: '1.5' },
  { label: '1.4', id: '1.4' },
  { label: '1.3', id: '1.3' },
  { label: '1.2', id: '1.2' },
  { label: '1.1', id: '1.1' },
  { label: '1.0', id: '1.0' },
  { label: '0.9', id: '0.9' },
  { label: '0.8', id: '0.8' },
  { label: '0.7', id: '0.7' },
  { label: '0.6', id: '0.6' },
  { label: '0.5', id: '0.5' },
  { label: '0.4', id: '0.4' },
  { label: '0.3', id: '0.3' },
  { label: '0.2', id: '0.2' },
  { label: '0.1', id: '0.1' },
]
const FULL_TIME_FTE_MAX = 1.5
const FULL_TIME_FTE_MIN = 0.8
const PART_TIME_FTE_MAX = 0.8
const PART_TIME_FTE_MIN = 0.2

export function getEstimatedFteOptions(jobType: string) {
  return estimatedFteOptions.filter(({ id }) => {
    if (jobType === FULL_TIME_VALUE) {
      return Number(id) >= FULL_TIME_FTE_MIN && Number(id) <= FULL_TIME_FTE_MAX
    } else if (jobType === PART_TIME_VALUE) {
      return Number(id) >= PART_TIME_FTE_MIN && Number(id) <= PART_TIME_FTE_MAX
    }
    return true
  })
}

export const EMPLOYER_TYPE_SELF_EMPLOYED = 'selfEmployed'
const EMPLOYER_TYPE_HOSPITAL_OR_HEALTH_SYSTEM = 'hospitalOrHealthSystem'
export const EMPLOYER_TYPE_PRIVATE_MEDICAL_GROUP = 'medicalGroup'
const EMPLOYER_TYPE_OUTPATIENT_CENTER = 'outpatientCenter'
const EMPLOYER_TYPE_GOVERNMENT_MILITARY = 'governmentMilitary'
const EMPLOYER_TYPE_COMMUNITY_OR_PUBLIC_HEALTH_SYSTEM =
  'communityOrPublicHealthSystem'
const EMPLOYER_TYPE_RETAIL_CLINIC_OR_TELEMEDICINE = 'retailClinicOrTelemedicine'
const EMPLOYER_TYPE_CORPORATE_PHARMA_OR_CONSULTING =
  'corporatePharmaOrConsulting'
export const EMPLOYER_TYPE_OTHER = 'other'

export const EMPLOYER_TYPE_DETAILS_ACADEMIC_MEDICAL_CENTER =
  'academicMedicalCenter'

export const employerTypeDetailsOptions = {
  [EMPLOYER_TYPE_SELF_EMPLOYED]: [],
  [EMPLOYER_TYPE_HOSPITAL_OR_HEALTH_SYSTEM]: [
    { label: 'Private Community Hospital', id: 'privateCommunityHospital' },
    {
      label: 'Academic Medical Center',
      id: EMPLOYER_TYPE_DETAILS_ACADEMIC_MEDICAL_CENTER,
    },
    { label: 'State-Run Community Hospital', id: 'stateRunCommunityHospital' },
    { label: 'HMO or Health Plan', id: 'hmoOrHealthPlan' },
  ],
  [EMPLOYER_TYPE_PRIVATE_MEDICAL_GROUP]: [
    {
      label: 'Single-Specialty Medical Group',
      id: 'singleSpecialtyGroup',
    },
    {
      label: 'Multi-Specialty Medical Group',
      id: 'multiSpecialtyGroup',
    },
    { label: 'Independent / Solo Group', id: 'soloOrIndependentGroup' },
  ],
  [EMPLOYER_TYPE_OUTPATIENT_CENTER]: [
    { label: 'ASC', id: 'asc' },
    { label: 'Specialty Clinic', id: 'specialtyCenter' },
    { label: 'Urgent Care Clinic', id: 'urgentCare' },
  ],
  [EMPLOYER_TYPE_GOVERNMENT_MILITARY]: [
    {
      label: 'Govt Hospital / Health System',
      id: 'governmentHospitalOrHealthSystem',
    },
    {
      label: 'Govt Public Health Center',
      id: 'governmentPublicHealthCenter',
    },
    { label: 'Military', id: 'military' },
  ],
  [EMPLOYER_TYPE_COMMUNITY_OR_PUBLIC_HEALTH_SYSTEM]: [
    { label: 'Community Health Center (FQHC)', id: 'communityHealthClinic' },
    { label: 'Non-Profit / NGO', id: 'nonProfitNgo' },
  ],
  [EMPLOYER_TYPE_RETAIL_CLINIC_OR_TELEMEDICINE]: [
    { label: 'Retail Clinic', id: 'retailClinic' },
    { label: 'Telemedicine Company', id: 'telemedicine' },
  ],
  [EMPLOYER_TYPE_CORPORATE_PHARMA_OR_CONSULTING]: [
    { label: 'Corporate Health Clinic', id: 'corporateHealthClinic' },
    {
      label: 'Pharma / Medical Device Company',
      id: 'pharmaOrMedicalDeviceCompany',
    },
    { label: 'Consulting Firm', id: 'consultingFirm' },
  ],
  [EMPLOYER_TYPE_OTHER]: [],
}

export const CALL_TYPE_IN_HOUSE_VALUE = 'inHouse'
export const CALL_TYPE_AT_HOME_VALUE = 'atHome'
export const CALL_TYPE_BOTH_VALUE = 'both'

export const callTypeOptions = [
  { label: 'In-House', id: CALL_TYPE_IN_HOUSE_VALUE },
  { label: 'At-Home', id: CALL_TYPE_AT_HOME_VALUE },
  { label: 'Both (In-House & At-Home)', id: CALL_TYPE_BOTH_VALUE },
]
export const CLINICAL_AND_LEADERSHIP_VALUE = 'clinicalAndLeadership'
export const CLINICAL_ONLY_VALUE = 'clinicalOnly'
export const responsibilitiesOptions = [
  { label: 'Clinical Only', id: CLINICAL_ONLY_VALUE },
  {
    label: 'Clinical + (Leadership, Teaching, or Research)',
    id: CLINICAL_AND_LEADERSHIP_VALUE,
  },
]

const hoursRules = {
  min: { value: 1, message: 'Must work at least 1 hour a week' },
  max: { value: 168, message: 'Cannot work more than 168 hours a week' },
}

const partTimeHoursRules = {
  min: { value: 10, message: 'Must be between 10 and 30 hours' },
  max: { value: 30, message: 'Must be between 10 and 30 hours' },
}

const fullTimeHoursRules = {
  min: { value: 25, message: 'Must be between 25 and 70 hours' },
  max: { value: 70, message: 'Must be between 25 and 70 hours' },
}

export function getHoursRules(jobType: string) {
  if (jobType === PART_TIME_VALUE) {
    return partTimeHoursRules
  } else if (jobType === FULL_TIME_VALUE) {
    return fullTimeHoursRules
  }
  return hoursRules
}

export const WEEKDAYS_ONLY_VALUE = 'weekdaysOnly'
export const VARIABLE_SCHEDULE_VALUE = 'variable'
export const scheduledDaysOptions = [
  { label: 'Weekdays Only', id: WEEKDAYS_ONLY_VALUE },
  { label: 'It Varies', id: VARIABLE_SCHEDULE_VALUE },
]
export const DAYS_VALUE = 'days'
export const NIGHTS_VALUE = 'nights'
export const VARIABLE_SHIFT_TIMING_VALUE = 'variable'
export const shiftTimingOptions = [
  { label: 'Days', id: DAYS_VALUE },
  { label: 'Nights', id: NIGHTS_VALUE },
  { label: 'It Varies', id: VARIABLE_SHIFT_TIMING_VALUE },
]
const EIGHT_SCHEDULED_HOURS_VALUE = '8s'
const TEN_SCHEDULED_HOURS_VALUE = '10s'
const TWELVE_SCHEDULED_HOURS_VALUE = '12s'
const TWENTY_FOUR_SCHEDULED_HOURS_VALUE = '24s'
export const VARIABLE_SCHEDULED_HOURS_VALUE = 'variable'
export const scheduledHoursOptions = [
  { label: "8's", id: EIGHT_SCHEDULED_HOURS_VALUE },
  { label: "10's", id: TEN_SCHEDULED_HOURS_VALUE },
  { label: "12's", id: TWELVE_SCHEDULED_HOURS_VALUE },
  { label: "24's", id: TWENTY_FOUR_SCHEDULED_HOURS_VALUE },
  { label: 'It Varies', id: VARIABLE_SCHEDULED_HOURS_VALUE },
]
export const callScheduleOptions = [
  { id: CALL_SCHEDULE_NONE_VALUE, label: 'None' },
  { id: '1:2', label: '1:2' },
  { id: '1:3', label: '1:3' },
  { id: '1:4', label: '1:4' },
  { id: '1:5', label: '1:5' },
  { id: '1:6', label: '1:6' },
  { id: '1:7', label: '1:7' },
  { id: '1:8+', label: '1:8+' },
  { id: CALL_SCHEDULE_OTHER_VALUE, label: 'Other' },
]
export const employerTypeOptions = [
  { label: 'Self-Employed', id: EMPLOYER_TYPE_SELF_EMPLOYED },
  {
    label: 'Hospital or Health System',
    id: EMPLOYER_TYPE_HOSPITAL_OR_HEALTH_SYSTEM,
  },
  { label: 'Medical Group', id: EMPLOYER_TYPE_PRIVATE_MEDICAL_GROUP },
  { label: 'Outpatient Center', id: EMPLOYER_TYPE_OUTPATIENT_CENTER },
  { label: 'Government / Military', id: EMPLOYER_TYPE_GOVERNMENT_MILITARY },
  {
    label: 'Community or Public Health System',
    id: EMPLOYER_TYPE_COMMUNITY_OR_PUBLIC_HEALTH_SYSTEM,
  },
  {
    label: 'Retail Clinic or Telemedicine',
    id: EMPLOYER_TYPE_RETAIL_CLINIC_OR_TELEMEDICINE,
  },
  {
    label: 'Corporate, Pharma, or Consulting',
    id: EMPLOYER_TYPE_CORPORATE_PHARMA_OR_CONSULTING,
  },
  { label: 'Other', id: EMPLOYER_TYPE_OTHER },
]

const ACADEMIC_AFFILIATION_NONE_VALUE = 'none'
export const ACADEMIC_AFFILIATION_FULL_VALUE = 'fullAcademic'
export const academicAffiliationOptions = [
  { label: 'Fully Academic', id: ACADEMIC_AFFILIATION_FULL_VALUE },
  { label: 'Academic Affiliated', id: 'academicAffiliated' },
  { label: 'None', id: ACADEMIC_AFFILIATION_NONE_VALUE },
]

// use the below for onboarding.
export const PRN_VALUE = 'prn'
export const LOCUM_TENENS_VALUE = 'locumTenens'
export const PART_TIME_VALUE = 'partTime'
export const FULL_TIME_VALUE = 'fullTime'
export enum JobType {
  fullTime = 'Full-Time',
  partTime = 'Part-Time',
  prn = 'PRN',
  locumTenens = 'Locum Tenens',
}

export const jobTypeOptions = Object.entries(JobType).map(([id, label]) => {
  return {
    id,
    label: id === LOCUM_TENENS_VALUE ? 'Locums' : label,
  }
})

// use the below for salaries.
export const SALARY_FULL_TIME_VALUE = '-'
export const SALARY_LOCUM_TENENS_VALUE = 'locums'
export const SALARY_PRN_VALUE = 'prn'
export const SALARY_PART_TIME_VALUE = 'part-time'
export const jobTypeSlugOptions = [
  { label: 'Full-Time', id: SALARY_FULL_TIME_VALUE },
  { label: 'Part-Time', id: SALARY_PART_TIME_VALUE },
  { label: 'PRN', id: SALARY_PRN_VALUE },
  { label: 'Locum Tenens', id: SALARY_LOCUM_TENENS_VALUE },
]

export const employerTaxStatusOptions = [
  { label: 'For-Profit', id: 'forProfit' },
  { label: 'Not-for-Profit - 501(c)(3)', id: 'notForProfit' },
]
